export default __webpack_public_path__ + "static/two-phones-ba793551375042842c045e4ab8775d7c.png";